var path = '/assets/js/dashboard/components/charts/timeChart/timeChart.html';
var html = "<span class=\"time-chart-data-excessive\" ng-show=\"$ctrl.tooMuchData\">\n    <span translate>common.chart.data.excessive</span>\n</span>\n\n<div class=\"time-chart-chart\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;